<script>
	import { Button, Col, Row } from "sveltestrap";
	import { Sveltik, Field } from "sveltik";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import { onMount, afterUpdate, onDestroy } from "svelte";
	import client from "../../../services/client";
	import { navigate } from "svelte-routing";
	import ErrorMessageHandler from "../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { errorMessage, loading } from "../../../store/store";
	import Loader from "../../../components/Loader/Loader.svelte";
	import { extractErrorMessage } from "src/utils/misc";

	async function handleSubmit(values) {
		try {
			errorMessage.set("");
			const res = await client("/v0/Group/Create", {
				method: "POST",
				version: "Tasking",
				data: {
					name: values.name,
				},
			});
			if (res.status === 200) {
				navigate("/master-data/group");
			}
		} catch (err) {
			extractErrorMessage(err);
		}
	}

	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
	let load;
	loading.subscribe((value) => {
		load = value;
	});
</script>

<Sveltik
	initialValues={{
		name: "",
	}}
	onSubmit={handleSubmit}
	enableReinitialize={true}
	let:props
>
	<form on:submit|preventDefault={props.handleSubmit}>
		<Row>
			<Col>
				<ErrorMessageHandler message={err} />
				<div>
					<PageHeader title="Create Group" />
					<Col>
						<Row>
							<Col>
								<label for="mobile" class="d-flex pt-3">
									<span> Name* </span>
								</label>
							</Col>
						</Row>
						<Row>
							<Col xs={4}>
								<Field>
									<input
										type="text"
										class="form-control getgo input"
										name="name"
										on:input={props.handleInput}
										on:blur={props.handleBlur}
										value={props.values.name}
									/>
								</Field>
							</Col>
						</Row>
					</Col>
					<Col class="d-flex justify-content-start pt-2 col-6">
						<Row>
							<Col>
								<Button
									class="themeButton primary "
									disabled={load}
								>
									{#if load}
										<Loader />
									{:else}
										Create
									{/if}
								</Button>
							</Col>
						</Row>
					</Col>
				</div></Col
			>
		</Row>
	</form>
</Sveltik>
